<template>
  <default-layout>
    <section slot="content">
      <v-container
        fluid
      >
        <v-row justify="center" v-if="quantity != 0">
          <v-col cols="12" md="10" xs="12">
            <v-row justify="center">
              <!-- ********************************** -->
              <v-col cols="12" lg="8" md="12" sm="12" xs="12">
                <v-card>
                  <v-card-title class="justify-center mb-4">Carrito de compras</v-card-title>
                  <template v-for="(item, index) in cartDetailTmp">
                    <v-card-title>
                      <v-row no-gutters>
                        <v-col cols="6" md="2" sm="2" xs="6">
                          <v-card class="pa-0 ma-0 mt-n4 overline text-center" style="border: 0" outlined elevation="0">
                            <div>
                              <v-avatar
                                size="80"
                                tile
                              >
                                <v-img :src="item.product_color.product_color_image[0].image"></v-img>
                              </v-avatar>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="6" md="2" sm="2" xs="6">
                          <v-card class="body-2 text-center" style="border: 0" outlined elevation="0">
                            <div class="name-product">{{ item.product.name }}</div>
                            <v-card-text class="justify-center">
                              <a :disabled="disabledDelete" @click="deleteCart(item)">X Eliminar</a>
                              <template v-if="item.stock === 0">
                                <br>
                                <i style="color: red; font-size: 11px !important">Cantidad no disponible.</i>
                              </template>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" md="2" sm="2" xs="12">
                          <v-card class="body-2 text-center" style="border: 0px" outlined elevation="0">
                            S/ {{ item.unit_price }}
                          </v-card>
                        </v-col>
                        <v-col cols="12" md="4" sm="4" xs="12">
                            <v-card-actions class="justify-center">
                              <v-text-field
                                :style="[ !$vuetify.breakpoint.xsOnly ? {'top': '-18px !important'} : {'top': '0px'}]"
                                type="number"
                                min="1"
                                class="body-2 input-price"
                                outlined
                                dense
                                v-model="item.quantity"
                                disabled readonly
                              >
                                <template v-slot:prepend>
                                  <v-btn style="top: -7px; min-width: 0" :disabled="item.quantity == 1 || (item.quantity > 1 && disabledUpdate)" @click="decrement(item)">
                                    <v-icon center>
                                      remove
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <template slot="append-outer">
                                  <v-btn :disabled="disabledUpdate" style="top: -7px; min-width: 0" @click="increment(item)">
                                    <v-icon center>
                                      add
                                    </v-icon>
                                  </v-btn>
                                </template>
                              </v-text-field>
                            </v-card-actions>
                        </v-col>
                        <v-col cols="12" md="2" sm="2" xs="12">
                          <v-card class="body-2 text-center" style="border: 0" outlined elevation="0">
                            S/ {{ item.amount }}
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-col cols="12" sm="12">
                        <v-card-title primary-title>
                          <v-divider></v-divider>
                        </v-card-title>
                      </v-col>
                    </v-card-title>
                  </template>
                </v-card>
              </v-col>
              <!-- ********************************** -->
              <v-col cols="12" lg="4" md="12" sm="12" xs="12">
                <v-card>
                  <v-card-title class="justify-center">Valida tu cupón</v-card-title>
                  <v-card-text class="mt-5">
                    <v-text-field
                      :style="[ !$vuetify.breakpoint.xsOnly ? {'top': '-18px !important'} : {'top': '0px'}]"
                      min="1"
                      class="body-2"
                      outlined
                      dense
                      placeholder="Ingrese Cupón..."
                      v-model="cartTmp.coupon_code"
                    >
                      <template slot="append-outer">
                        <v-btn color="primary btn-to-pay" style="top: -7px; min-width: 0" @click="validateCoupon">
                          VALIDAR
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-card-text>
                </v-card>
                <v-card class="mt-2">
                  <v-card-title class="justify-center">Resumen de la compra</v-card-title>
                  <v-card-title class="mt-n5">
                    <v-row no-gutters>
                      <v-col cols="6" sm="6" xs="6">
                        <v-card class="pa-0 ma-0 overline" style="border: 0" outlined elevation="0">
                          Subtotal
                        </v-card>
                      </v-col>
                      <v-col cols="6" sm="6" xs="6">
                        <v-card class="pa-0 ma-0 mt-1 body-2 text-right" style="border: 0" outlined elevation="0">
                          S/ {{ cartTmp.subtotal }}
                        </v-card>
                      </v-col>
                      <v-col cols="6" sm="6" xs="6">
                        <v-card class="pa-0 ma-0 overline" style="border: 0px" outlined elevation="0">
                          Envío
                        </v-card>
                      </v-col>
                      <v-col cols="6" sm="6" xs="6">
                        <v-card class="pa-0 ma-0 mt-1 body-2 text-right" style="border: 0" outlined elevation="0">
                          S/ {{ cartTmp.shipping_price }}
                        </v-card>
                      </v-col>
                      <template v-if="cartTmp.coupon > 0 && cartTmp.coupon_code">
                        <v-col cols="6" sm="6" xs="6">
                          <v-card class="pa-0 ma-0 overline" style="border: 0px" outlined elevation="0">
                            Cupón
                          </v-card>
                        </v-col>
                        <v-col cols="6" sm="6" xs="6">
                          <v-card class="pa-0 ma-0 mt-1 body-2 text-right" style="border: 0" outlined elevation="0">
                            - S/ {{ cartTmp.coupon }}
                          </v-card>
                        </v-col>
                      </template>
                      <v-col cols="6" sm="6" xs="6">
                        <v-card class="pa-0 ma-0 overline" style="border: 0px" outlined elevation="0">
                          Total
                        </v-card>
                      </v-col>
                      <v-col cols="6" sm="6" xs="6">
                        <v-card class="pa-0 ma-0 text-right" style="border: 0" outlined elevation="0">
                          S/ {{ cartTmp.total }}
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-title>

                  <v-card-actions class="white justify-center mb-16">
                    <v-row row d-flex nowrap>
                      <v-col
                        cols="12"
                        sm="12"
                        xs="12"
                        class=" justify-center"
                      >
                        <v-btn color="primary btn-to-pay" elevation="2" @click="validatePayment()">

                          IR A PAGAR
                          <v-icon right>trending_flat</v-icon>
                        </v-btn>
                      </v-col>

                      <v-col
                        cols="12"
                        sm="12"
                        xs="12"
                        class=" justify-center"
                      >
                        <v-btn
                          color="white--text"
                          style="font-size: 11px !important; background: #45c554"
                          elevation="2"
                          target="_blank"
                          :href="goWhatsapp()"
                          block
                        >
                          <v-icon left>mdi-whatsapp</v-icon>
                          COMPRAR POR WHATSAPP
                        </v-btn>
                      </v-col>

                      <v-col
                        cols="12"
                        sm="12"
                        xs="12"
                        class=" justify-center"
                      >
                        <v-btn color="primary btn-keep-buying" elevation="2" @click="redirect('HomePage')" outlined>
                          SEGUIR COMPRANDO
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-10" v-else>
          <v-col cols="12" md="10" xs="12">
            <v-row justify="center">
              <v-col cols="12" lg="4" md="6" sm="8" xs="12">
                <v-card mb-4 style="border: 0" outlined elevation="0">
                  <v-card-title class="justify-center">
                    <v-icon size="80" color="primary">shopping_cart</v-icon>
                  </v-card-title>
                  <v-card-title class="justify-center">
                      <p class="text--primary text-center">
                        ¡Tu carrito de compras esta vacío!
                      </p>
                    </v-card-title>
                  <v-card-text>
                    <div class="text--primary text-center">
                      Aún no has agregado productos a tu carrito de compras. Visita nuestra página principal y descubre todo lo que tenemos para ti.
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      @click="redirect('HomePage')"
                      color="primary"
                      block
                    >
                      Ver productos
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <template>
          <div class="text-center ma-2">
            <v-snackbar
              v-model="snackbar"
              :color="color"
              top
            >
              <template v-if="Array.isArray(text)">
                <template v-for="value in text">
                  {{ value }}<br>
                </template>
              </template>
              <template v-else>
                {{ text }}
              </template>
              <template v-slot:action="{ attrs }">
                <v-btn
                  color="white"
                  text
                  v-bind="attrs"
                  @click="snackbar = false"
                >
                  X
                </v-btn>
              </template>
            </v-snackbar>
          </div>
        </template>
      </v-container>
    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import CartStore from '@/stores/Cart'
  import constants from '@/constants/index'

  export default {
    name: 'Cart',
    components: {
      DefaultLayout
    },
    data () {
      return {
        cartTmp: {},
        cartDetailTmp: [],
        snackbar: false,
        text: '',
        color: '#399826',
        disabledDelete: false,
        disabledUpdate: false,
      }
    },
    computed: {
      quantity() {
        return CartStore.getters.quantity;
      }
    },
    methods: {
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      getCart() {
        axios.get(process.env.DINO.PATH.GET_CART_DETAIL)
        .then(response => {
          this.cartTmp = response.data.cartTmp;
          this.cartDetailTmp = response.data.cartDetailTmp;
        })
        .catch(err => {
        })
        .then(() => {
        });
      },

      redirect: function(name) {
        this.$router.push({ name: name }).catch(err => {});
      },

      increment(item) {
        this.disabledUpdate = true;
        item.quantity = item.quantity + 1;
        this.updateCart(item);
      },

      decrement(item) {
        this.disabledUpdate = true;
        item.quantity = item.quantity - 1;
        this.updateCart(item);
      },

      updateCart (item) {
        const request = {
          id: item.id,
          product_id: item.product.id,
          quantity: item.quantity
        };

        axios.post(process.env.DINO.PATH.UPDATE_CART, request)
        .then(response => {
          const color = response.data.success ? 'green' : 'red';
          this.showMessage(response.data.message, color);
          setTimeout(() => this.disabledUpdate = false, constants.NUMBER_2000);
        })
        .catch(err => {
          this.snackbar = true;
          this.text = '¡Hubo un error al actualizar, por favor actualizar la página!';
          this.color = 'red';
          setTimeout(() => this.disabledUpdate = false, constants.NUMBER_2000);
        })
        .then(() => {
          this.getCart();
          CartStore.dispatch('getCartQuantity')
        });
      },

      deleteCart (item) {
        this.disabledDelete = true;

        const request = {
          id: item.id
        };

        axios.post(process.env.DINO.PATH.DELETE_CART, request)
        .then(response => {
          const color = response.data.success ? 'green' : 'red';
          this.showMessage(response.data.message, color);
          setTimeout(() => this.disabledDelete = false, constants.NUMBER_2000);
        })
        .catch(err => {
          this.snackbar = true;
          this.text = '¡Hubo un error al eliminar, por favor actualizar la página!';
          this.color = 'red';
          setTimeout(() => this.disabledDelete = false, constants.NUMBER_2000);
        })
        .then(() => {
          this.getCart();
          CartStore.dispatch('getCartQuantity')
        });
      },

      validateCoupon () {
        this.disabledDelete = true;

        const request = {
          cart_tmp_id: this.cartTmp.id,
          coupon_code: this.cartTmp.coupon_code
        };

        axios.post(process.env.DINO.PATH.VALIDATE_COUPON, request)
        .then(response => {
          const color = response.data.success ? 'green' : 'red';
          this.showMessage(response.data.message, color);
          setTimeout(() => this.disabledDelete = false, constants.NUMBER_2000);
        })
        .catch(err => {
          this.snackbar = true;
          this.text = '¡Hubo un error al validar cupón, por favor actualizar la página!';
          this.color = 'red';
          setTimeout(() => this.disabledDelete = false, constants.NUMBER_2000);
        })
        .then(() => {
          this.getCart();
        });
      },

      validatePayment () {
        let hasError = false;
        let messageErrors = ['No está disponible la cantidad deseada para el ítem(s):'];

        this.cartDetailTmp.forEach((data, index) => {
          if (data.stock === 0) {
            messageErrors.push(data.product.name);
            hasError = true;
          }
        });

        if (hasError) {
          this.showMessage(messageErrors, 'red');
          setTimeout(() => this.disabledDelete = false, constants.NUMBER_2000);
          return;
        } else {
          this.redirect('Payment')
        }
      },

      goWhatsapp () {
        let message = '*DINO!* - Quiero comprar estos productos.%0D%0A%0D%0A';
        this.cartDetailTmp.forEach((data, index) => {
          message = message + '*' + data.product.name.toUpperCase() + '*%0D%0A*P. Unitario:*%20S/' + data.unit_price +
          '%0D%0A*Unidad:*%20' + data.quantity + '%0D%0A*Total:*%20S/' + data.amount + '%0D%0A%0D%0A';
        });

        message = message + '*Total de Compra:*%20S/' + this.cartTmp.subtotal + '%0D%0A%0D%0A_%C2%A1Gracias+%21_';

        return `https://api.whatsapp.com/send?phone=51987839662&text=${message}`;
      }

    },
    mounted: function () {
      this.getCart();
    }
  }
</script>
<style scoped>

.btn-to-pay {
  width: 100%;
  font-size: 14px !important
}

.text--btn-keep-buying {
  width: 100% !important;
  font-size: 14px !important
}

.v-input--is-disabled:not(.v-input--is-readonly) {
    pointer-events: none;
}

.input-price >>> input[type='number'] {
  -moz-appearance:textfield;
  text-align: center;
}
.input-price >>> input::-webkit-outer-spin-button,
.input-price >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  text-align: center;
}

.name-product {
  word-break: normal;
}

</style>



// WEBPACK FOOTER //
// src/views/Cart.vue